<template>
  <div  class="m-0 p-0" >
    <ValidationProvider :rules="validation" v-slot="{ errors }" :name="label">
      <div class="dateInputWrapper form-group">
        <label v-if="labelOnTop" class="input-label">
          {{$t(label)}}
          <span v-if="validation.includes('required')">*</span>
          <span v-else>{{$t('(optional)')}}</span>
        </label>
        <datepicker
          :value="value"
          :style="styles"
          :class="{'is-invalid': errors.length}"
          @selected="updateValue"
          @opened="floatLabel = true"
          @closed="floatLabel = false"
          ref="input"
          :name="name"
          :id="id"
          language="de"
          v-bind="datepickerParams"
          required
        ></datepicker>
        <!-- <img v-if="errors.length" class="error_min inputError" src="../../assets/icons/risk-icon.svg" height="18px" width="18px" alt=""> -->
        <span
          v-if="!labelOnTop"
          :class="{floatLabel: floatLabel || value}"
          class="floating-label"
        >{{label}}</span>
      </div>
      <div class="validation-error" v-if="errors.length">
        {{errors[0]}}
      </div>
    </ValidationProvider>
    <!-- <div class="m-0 p-0" v-else>
      <div class="dateInputWrapper form-group">
        <datepicker
          :value="value"
          :style="styles"
          :class="{'is-invalid': errors.length}"
          @selected="updateValue"
          @opened="floatLabel = true"
          @closed="floatLabel = false"
          ref="input"
          :name="name"
          :id="id"
          v-bind="datepickerParams"
          required
        ></datepicker>
        <span
          :class="{floatLabel: floatLabel}"
          class="floating-label"
        >{{label}}</span>
      </div>
    </div> -->
  </div>
</template>

<script>

import Datepicker from "@hokify/vuejs-datepicker";
import "@hokify/vuejs-datepicker/dist/vuejs-datepicker.css"

export default {
  name: "date-input",
  components: {
    Datepicker
  },
  mounted () {
    document.getElementById(this.id).setAttribute('placeholder', this.placeholder)
  },
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    value: {
      type: Date
    },
    validation: {
      type: String,
      required: false
    },
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    params: {
      type: Object,
      required: false
    },
    labelOnTop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    datepickerParams () {
      const params = { ...this.params }
      if (params.disabledDates) {
        if (params.disabledDates.to) {
          params.disabledDates.to = this.convertToDate(params.disabledDates.to)
        }
        if (params.disabledDates.from) {
          params.disabledDates.from = this.convertToDate(params.disabledDates.from)
          params.openDate = params.disabledDates.from
        }
      }
      return params
    }
  },
  data () {
    return {
      floatLabel: false
    }
  },
  methods: {
    updateValue (value) {
      this.$emit("component-updated", {
        value
      });
    },
    convertToDate (date) {
      if (date === "today") {
        return new Date()
      } else if (date === "18years") {
        const date = new Date()
        date.setFullYear(date.getFullYear() - 18)
        return date
      } else {
        return new Date(date)
      }
    }
  }
};
</script>

<style scoped lang="scss">

  .inputError {
    position: absolute;
    right: 10px;
    top: 12px;
  }
.dateInputWrapper {
  position: relative;

  /deep/ input {
    background: #FFFFFF;
    border: 1px solid #D1E7FF !important;
    box-sizing: border-box;
    border-radius: 8px;
    transition: border-color 0.15s;
    height: 48px;
    width: 100%;
    padding: 1rem;
  }

  .floating-label {
    position: absolute;
    top: 50%;
    left: 12px;
    transition: transform .1s;
    pointer-events: none;
    transform-origin: 0 100%;
    transform: translateY(-50%);

    font: normal normal 300 16px/22px 'Plus Jakarta Sans';
    letter-spacing: 0px;
    color: #1B1B1B;
    opacity: 0.5;

    &.floatLabel {
      transform: translateY(-145%) scale(0.7);
    }
  }
}
</style>
